import { render, staticRenderFns } from "./ConfiguracaoRelatorio.vue?vue&type=template&id=fdfc71be&scoped=true&"
import script from "./ConfiguracaoRelatorio.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc71be",
  null
  
)

export default component.exports